import { platformNames } from '../constants/platform-names.contants';

export const addPharmacyToTemplate = (platform, pharmacy) => {
	if (platform === platformNames.mkt) {
		return `${pharmacy === platformNames.pharol ? '' : ` de ${pharmacy.toUpperCase()}`}`;
	}
	return '';
};
